import { useEffect, useMemo, useState } from 'react'

import { useRoomAPI } from 'components/contexts/RoomAPI.context'

/** Provides sorted room list with a bounds-safe active room index. */
export function useActiveRoom() {
  const { getAllRooms } = useRoomAPI()

  const [activeRoomIndex, setActiveRoomIndex] = useState<number>(0)

  const allRooms = useMemo(() => getAllRooms().sort((roomA, roomB) => roomA.roomCreationSortingOrder - roomB.roomCreationSortingOrder), [getAllRooms])
  const activeRoom = useMemo(() => allRooms[activeRoomIndex], [activeRoomIndex, allRooms])

  useEffect(() => {
    if (activeRoomIndex >= allRooms.length && allRooms.length > 0) {
      setActiveRoomIndex(allRooms.length - 1)
    }
  }, [activeRoomIndex, allRooms.length])

  return { allRooms, activeRoom, activeRoomIndex, setActiveRoomIndex }
}
